import React from 'react';
import { Row, Col } from 'antd';
import { Label } from '../../../components/Label';
import { FormItem } from '../../../components/FormItem';
import { SelectWithCreation } from '@/components/ui/Inputs';
import type { InputDefaultProps } from '../types';

export function Organization({ fieldName, isLoading = false, data = [] }: Readonly<InputDefaultProps>): JSX.Element {
	return (
		<Col span={24}>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Label isRequired>Company</Label>
				</Col>
				<Col span={24}>
					<FormItem name={[fieldName, 'organization_id']}>
						<SelectWithCreation size="large" loading={isLoading} selectOptions={data} disabled />
					</FormItem>
				</Col>
			</Row>
		</Col>
	);
}
